import { CampaignCard } from '@/features/campaign-card';
import { Campaign, useGetAllCampaignsQuery } from '@/models/campaign';
import { Placeholder } from './Placeholder';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { Button } from '@/components/Button';
import { NavLink } from 'react-router';
import AddIcon from '@mui/icons-material/Add';

export const Campaigns = () => {
  const { data, isLoading } = useGetAllCampaignsQuery();

  return (
    <div className="w-full px-3 sm:px-4 md:px-6">
      {/* Header */}
      <div className="flex flex-col xs:flex-row xs:items-center xs:justify-between mb-4 gap-3">
        <Typography
          variant="h5"
          fontWeight={600}
          className="text-center sm:text-left"
        >
          <Trans i18nKey="page.campaigns.title" />
        </Typography>

        <NavLink to="/client/create/ad" className="self-center sm:self-end">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
            size="medium"
          >
            <Trans i18nKey="ads.create_ad_text" />
          </Button>
        </NavLink>
      </div>

      {/* Content */}
      {isLoading && <Placeholder size={8} />}

      {!isLoading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
          {data?.map((it: Campaign) => (
            <CampaignCard
              key={it.id}
              id={it.id}
              title={it.title}
              heroImage={it.heroImage}
              description={it.description}
              gradientPlaceholder={it.gradientPlaceholder}
            />
          ))}
        </div>
      )}
    </div>
  );
};
